import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight, Search, ShoppingCart, User, Heart, TrendingUp, Tag, Zap, Star, Flame } from 'lucide-react';
export function App() {
  const [activeCategory, setActiveCategory] = useState('home');
  const [searchQuery, setSearchQuery] = useState('');
  const [cartCount, setCartCount] = useState(0);
  const [wishlist, setWishlist] = useState(new Set());
  // Sample product data with real links and updated prices
  const categories = {
    blackfriday: [{
      id: 25,
      name: 'Amazon Fire TV Stick 4K Max',
      price: 54,
      source: 'Amazon',
      image: '📺',
      discount: 45,
      rating: 4.7,
      reviews: 89234,
      url: 'https://www.amazon.com/fire-tv-stick-4k-max/dp/B08MQZXN1X'
    }, {
      id: 26,
      name: 'PlayStation DualSense Controller',
      price: 69,
      source: 'Best Buy',
      image: '🎮',
      discount: 30,
      rating: 4.8,
      reviews: 45621,
      url: 'https://www.bestbuy.com/site/sony-dualsense-wireless-controller/6430163.p'
    }, {
      id: 27,
      name: 'Nintendo Switch Pro Controller',
      price: 69,
      source: 'Amazon',
      image: '🎮',
      discount: 25,
      rating: 4.9,
      reviews: 67234,
      url: 'https://www.amazon.com/Nintendo-Switch-Pro-Controller/dp/B01NAWKYZ0'
    }, {
      id: 28,
      name: 'Apple AirTag 4 Pack',
      price: 99,
      source: 'Amazon',
      image: '📍',
      discount: 20,
      rating: 4.8,
      reviews: 123456,
      url: 'https://www.amazon.com/Apple-AirTag-4-Pack/dp/B0933BVK6T'
    }, {
      id: 29,
      name: 'Amazon Fire HD 10 Tablet',
      price: 139,
      source: 'Amazon',
      image: '📱',
      discount: 40,
      rating: 4.6,
      reviews: 34521,
      url: 'https://www.amazon.com/Fire-HD-10-tablet/dp/B08F5Z3RK5'
    }, {
      id: 30,
      name: 'Logitech MX Keys Mini Keyboard',
      price: 99,
      source: 'Best Buy',
      image: '⌨️',
      discount: 35,
      rating: 4.7,
      reviews: 12890,
      url: 'https://www.bestbuy.com/site/logitech-mx-keys-mini/6471484.p'
    }, {
      id: 31,
      name: 'SteelSeries Arctis Nova 1 Headset',
      price: 59,
      source: 'Amazon',
      image: '🎧',
      discount: 50,
      rating: 4.6,
      reviews: 8934,
      url: 'https://www.amazon.com/SteelSeries-Arctis-Nova-Gaming-Headset/dp/B09ZYKNXZ9'
    }, {
      id: 32,
      name: 'Apple Magic Keyboard for iPad',
      price: 149,
      source: 'Best Buy',
      image: '⌨️',
      discount: 30,
      rating: 4.8,
      reviews: 23456,
      url: 'https://www.bestbuy.com/site/apple-magic-keyboard-for-ipad/6340372.p'
    }],
    trending: [{
      id: 1,
      name: 'JBL Tune 510BT Wireless Headphones',
      price: 49,
      source: 'Amazon',
      image: '🎧',
      discount: 20,
      rating: 4.6,
      reviews: 12453,
      url: 'https://www.amazon.com/JBL-Tune-510BT-Wireless-Headphones/dp/B08WM3LMJK'
    }, {
      id: 2,
      name: "Levi's 501 Original Fit Jeans",
      price: 69,
      source: "Levi's",
      image: '👖',
      discount: 15,
      rating: 4.6,
      reviews: 3892,
      url: 'https://www.levi.com/US/en_US/clothing/men/jeans/501-original-fit-mens-jeans/p/005010000'
    }, {
      id: 3,
      name: 'Nike Revolution 6 Running Shoes',
      price: 65,
      source: 'Nike',
      image: '👟',
      discount: 25,
      rating: 4.5,
      reviews: 8234,
      url: 'https://www.nike.com/t/revolution-6-mens-road-running-shoes-NC8zdD'
    }, {
      id: 4,
      name: 'Kindle (2022 Release)',
      price: 99,
      source: 'Amazon',
      image: '📱',
      discount: 10,
      rating: 4.7,
      reviews: 15678,
      url: 'https://www.amazon.com/Kindle-2022-release/dp/B09SWW583J'
    }, {
      id: 5,
      name: 'Polarized Classic Aviator Sunglasses',
      price: 29,
      source: 'Amazon',
      image: '🕶️',
      discount: 30,
      rating: 4.4,
      reviews: 5621,
      url: 'https://www.amazon.com/SOJOS-Classic-Aviator-Polarized-Sunglasses/dp/B01LXGQKR2'
    }, {
      id: 6,
      name: 'JBL Flip 5 Bluetooth Speaker',
      price: 99,
      source: 'Best Buy',
      image: '🔊',
      discount: 18,
      rating: 4.7,
      reviews: 4532,
      url: 'https://www.bestbuy.com/site/jbl-flip-5-portable-bluetooth-speaker/6332909.p'
    }],
    fashion: [{
      id: 7,
      name: 'Zara Faux Leather Biker Jacket',
      price: 89,
      source: 'Zara',
      image: '🧥',
      discount: 40,
      rating: 4.5,
      reviews: 892,
      url: 'https://www.zara.com/us/en/faux-leather-jacket-p03046304.html'
    }, {
      id: 8,
      name: 'ASOS Design Midi Dress',
      price: 45,
      source: 'ASOS',
      image: '👗',
      discount: 20,
      rating: 4.4,
      reviews: 1234,
      url: 'https://www.asos.com/us/asos-design/asos-design-midi-dress/prd/203456789'
    }, {
      id: 9,
      name: 'Nike Sportswear Club Hoodie',
      price: 55,
      source: 'Nike',
      image: '👕',
      discount: 15,
      rating: 4.6,
      reviews: 2341,
      url: 'https://www.nike.com/t/sportswear-club-fleece-pullover-hoodie-fNLm5z'
    }, {
      id: 10,
      name: 'Timex Weekender Watch',
      price: 45,
      source: 'Amazon',
      image: '⌚',
      discount: 35,
      rating: 4.7,
      reviews: 1876,
      url: 'https://www.amazon.com/Timex-Weekender-Watch-Leather-Strap/dp/B004VR9HP2'
    }, {
      id: 11,
      name: 'ASOS Crossbody Bag',
      price: 39,
      source: 'ASOS',
      image: '👜',
      discount: 25,
      rating: 4.5,
      reviews: 987,
      url: 'https://www.asos.com/us/asos-design/asos-design-crossbody-bag/prd/201234567'
    }, {
      id: 12,
      name: 'Nike Air Max SC Sneakers',
      price: 90,
      source: 'Nike',
      image: '👟',
      discount: 20,
      rating: 4.6,
      reviews: 3456,
      url: 'https://www.nike.com/t/air-max-sc-shoes-QFkv8r'
    }],
    electronics: [{
      id: 13,
      name: 'Anker PowerCore 20K PowerBank',
      price: 49,
      source: 'Amazon',
      image: '🔋',
      discount: 10,
      rating: 4.8,
      reviews: 8932,
      url: 'https://www.amazon.com/Anker-PowerCore-20100mAh-Portable-Charger/dp/B00X5RV14Y'
    }, {
      id: 14,
      name: 'Logitech M720 Triathlon Mouse',
      price: 39,
      source: 'Best Buy',
      image: '🖱️',
      discount: 20,
      rating: 4.6,
      reviews: 6721,
      url: 'https://www.bestbuy.com/site/logitech-m720-triathlon-wireless-optical-mouse/5579222.p'
    }, {
      id: 15,
      name: 'JBL Tune 230NC Earbuds',
      price: 99,
      source: 'Best Buy',
      image: '🎧',
      discount: 15,
      rating: 4.5,
      reviews: 3214,
      url: 'https://www.bestbuy.com/site/jbl-tune-230nc-true-wireless-noise-cancelling-earbuds/6501706.p'
    }, {
      id: 16,
      name: 'GoPro HERO Action Camera',
      price: 149,
      source: 'Best Buy',
      image: '📷',
      discount: 30,
      rating: 4.5,
      reviews: 2198,
      url: 'https://www.bestbuy.com/site/gopro-hero-waterproof-action-camera/6449593.p'
    }, {
      id: 17,
      name: 'Fitbit Inspire 3 Fitness Tracker',
      price: 99,
      source: 'Amazon',
      image: '⌚',
      discount: 25,
      rating: 4.4,
      reviews: 5432,
      url: 'https://www.amazon.com/Fitbit-Inspire-Health-Fitness-Tracker/dp/B0B5F9SZW7'
    }, {
      id: 18,
      name: 'Amazon Fire HD 8 Tablet',
      price: 99,
      source: 'Amazon',
      image: '📱',
      discount: 22,
      rating: 4.4,
      reviews: 7821,
      url: 'https://www.amazon.com/Fire-HD-8-tablet/dp/B099Z8HLHT'
    }],
    beauty: [{
      id: 19,
      name: 'Revlon One-Step Hair Dryer',
      price: 59,
      source: 'Amazon',
      image: '💨',
      discount: 20,
      rating: 4.5,
      reviews: 3421,
      url: 'https://www.amazon.com/Revlon-One-Step-Dryer-Volumizer-Brush/dp/B01LSUQSB0'
    }, {
      id: 20,
      name: 'Clinique Moisture Surge Set',
      price: 49,
      source: 'Sephora',
      image: '💄',
      discount: 30,
      rating: 4.6,
      reviews: 1892,
      url: 'https://www.sephora.com/product/moisture-surge-set-P478348'
    }, {
      id: 21,
      name: 'Foreo Luna Play Plus',
      price: 49,
      source: 'Sephora',
      image: '✨',
      discount: 25,
      rating: 4.5,
      reviews: 2341,
      url: 'https://www.sephora.com/product/luna-play-plus-P428002'
    }, {
      id: 22,
      name: 'Urban Decay Naked3 Palette',
      price: 54,
      source: 'Sephora',
      image: '🎨',
      discount: 15,
      rating: 4.7,
      reviews: 8765,
      url: 'https://www.sephora.com/product/naked3-P384099'
    }, {
      id: 23,
      name: 'The Ordinary Skincare Set',
      price: 45,
      source: 'Sephora',
      image: '🧴',
      discount: 10,
      rating: 4.6,
      reviews: 4321,
      url: 'https://www.sephora.com/brand/the-ordinary'
    }, {
      id: 24,
      name: 'Olaplex Hair Repair Treatment',
      price: 30,
      source: 'Sephora',
      image: '💇',
      discount: 18,
      rating: 4.8,
      reviews: 6543,
      url: 'https://www.sephora.com/product/olaplex-no-3-hair-perfector-P428224'
    }]
  };
  const stores = [{
    name: 'Amazon',
    logo: '📦',
    items: 1250,
    color: 'from-orange-500 to-yellow-500',
    url: 'https://www.amazon.com'
  }, {
    name: 'Nike',
    logo: '✓',
    items: 430,
    color: 'from-gray-700 to-black',
    url: 'https://www.nike.com'
  }, {
    name: 'Zara',
    logo: '👗',
    items: 890,
    color: 'from-blue-600 to-purple-600',
    url: 'https://www.zara.com'
  }, {
    name: 'Sephora',
    logo: '💋',
    items: 670,
    color: 'from-pink-500 to-red-500',
    url: 'https://www.sephora.com'
  }, {
    name: 'Best Buy',
    logo: '🔌',
    items: 520,
    color: 'from-blue-500 to-cyan-500',
    url: 'https://www.bestbuy.com'
  }, {
    name: 'ASOS',
    logo: '👕',
    items: 1100,
    color: 'from-green-500 to-teal-500',
    url: 'https://www.asos.com'
  }];
  const toggleWishlist = productId => {
    setWishlist(prev => {
      const newSet = new Set(prev);
      if (newSet.has(productId)) {
        newSet.delete(productId);
      } else {
        newSet.add(productId);
      }
      return newSet;
    });
  };
  const addToCart = productId => {
    setCartCount(prev => prev + 1);
  };
  const ProductCard = ({
    product
  }) => {
    const exchangeRate = 3.65;
    const shipping = 15;
    const totalILS = Math.round((product.price + shipping) * exchangeRate);
    const priceILS = Math.round(product.price * exchangeRate);
    const isWishlisted = wishlist.has(product.id);
    const handleProductClick = () => {
      window.open(product.url, '_blank', 'noopener,noreferrer');
    };
    return <div onClick={handleProductClick} className="flex-shrink-0 w-72 bg-gray-800 rounded-xl overflow-hidden hover:scale-105 hover:shadow-2xl transition-all duration-300 cursor-pointer group" data-id="element-0">
        <div className="relative h-56 bg-gradient-to-br from-purple-600 via-blue-600 to-cyan-500 flex items-center justify-center" data-id="element-1">
          <span className="text-8xl filter drop-shadow-lg" data-id="element-2">
            {product.image}
          </span>
          <div className="absolute top-3 left-3 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg" data-id="element-3">
            {product.discount}% OFF
          </div>
          <button onClick={e => {
          e.stopPropagation();
          toggleWishlist(product.id);
        }} className="absolute top-3 right-3 bg-white/20 backdrop-blur-sm p-2 rounded-full hover:bg-white/30 transition-all" data-id="element-4">
            <Heart size={20} className={isWishlisted ? 'fill-pink-500 text-pink-500' : 'text-white'} data-id="element-5" />
          </button>
          <div className="absolute bottom-3 left-3 right-3 bg-black/40 backdrop-blur-sm rounded-lg p-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-6">
            <div className="flex items-center text-yellow-400 text-sm" data-id="element-7">
              <Star size={14} className="fill-yellow-400 mr-1" data-id="element-8" />
              <span className="font-semibold" data-id="element-9">{product.rating}</span>
              <span className="text-gray-300 text-xs mr-2" data-id="element-10">
                ({product.reviews.toLocaleString()})
              </span>
            </div>
          </div>
        </div>
        <div className="p-4" data-id="element-11">
          <h3 className="text-white font-semibold mb-2 h-12 line-clamp-2 leading-tight" data-id="element-12">
            {product.name}
          </h3>
          <div className="flex items-center justify-between mb-3" data-id="element-13">
            <span className="text-gray-400 text-sm" data-id="element-14">{product.source}</span>
            <div className="text-left" data-id="element-15">
              <div className="text-green-400 font-bold text-lg" data-id="element-16">
                ${product.price}
              </div>
              <div className="text-gray-400 text-xs" data-id="element-17">≈ ₪{priceILS}</div>
            </div>
          </div>
          <div className="bg-gray-700/50 rounded-lg p-2 mb-3 text-xs" data-id="element-18">
            <div className="flex justify-between text-gray-300" data-id="element-19">
              <span data-id="element-20">מחיר + משלוח:</span>
              <span className="font-semibold text-white" data-id="element-21">₪{totalILS}</span>
            </div>
            <div className="text-gray-400 text-[10px] mt-1" data-id="element-22">
              כולל משלוח מוערך ~$15
            </div>
          </div>
          <button onClick={e => {
          e.stopPropagation();
          addToCart(product.id);
        }} className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-2.5 rounded-lg text-sm font-medium transition-all shadow-lg hover:shadow-xl" data-id="element-23">
            הוסף לעגלה
          </button>
        </div>
      </div>;
  };
  const ProductRow = ({
    title,
    products,
    icon: Icon
  }) => {
    const scrollRef = useRef(null);
    const scroll = direction => {
      if (scrollRef.current) {
        const scrollAmount = direction === 'left' ? -320 : 320;
        scrollRef.current.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    };
    return <div className="mb-10" data-id="element-24">
        <div className="flex items-center mb-5" data-id="element-25">
          <Icon className="text-blue-400 ml-3" size={28} data-id="element-26" />
          <h2 className="text-2xl font-bold text-white" data-id="element-27">{title}</h2>
        </div>
        <div className="relative group" data-id="element-28">
          <button onClick={() => scroll('left')} className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-black/70 hover:bg-black/90 text-white p-3 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-xl" data-id="element-29">
            <ChevronLeft size={24} data-id="element-30" />
          </button>
          <div ref={scrollRef} className="flex gap-5 overflow-x-auto scrollbar-hide pb-4 scroll-smooth" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-31">
            {products.map(product => <ProductCard key={product.id} product={product} data-id="element-32" />)}
          </div>
          <button onClick={() => scroll('right')} className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-black/70 hover:bg-black/90 text-white p-3 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-xl" data-id="element-33">
            <ChevronRight size={24} data-id="element-34" />
          </button>
        </div>
      </div>;
  };
  return <div className="min-h-screen bg-gray-900" dir="rtl" data-id="element-35">
      {/* Header */}
      <header className="bg-black/80 backdrop-blur-md sticky top-0 z-50 border-b border-gray-800 shadow-xl" data-id="element-36">
        <div className="container mx-auto px-6 py-4" data-id="element-37">
          <div className="flex items-center justify-between" data-id="element-38">
            <div className="flex items-center gap-8" data-id="element-39">
              <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500" data-id="element-40">
                150Dollar.com
              </h1>
              <nav className="hidden md:flex gap-6" data-id="element-41">
                <a href="https://www.amazon.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition font-medium" data-id="element-42">
                  בית
                </a>
                <a href="https://www.amazon.com/fashion" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition font-medium" data-id="element-43">
                  אופנה
                </a>
                <a href="https://www.amazon.com/electronics" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition font-medium" data-id="element-44">
                  אלקטרוניקה
                </a>
                <a href="https://www.amazon.com/beauty" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition font-medium" data-id="element-45">
                  יופי
                </a>
                <a href="https://www.amazon.com/sports-and-fitness" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition font-medium" data-id="element-46">
                  ספורט
                </a>
              </nav>
            </div>

            <div className="flex items-center gap-4" data-id="element-47">
              <div className="relative hidden md:block" data-id="element-48">
                <input type="text" placeholder="חפש מוצרים..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="bg-gray-800 text-white px-4 py-2 pr-10 rounded-full w-64 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" data-id="element-49" />
                <Search className="absolute right-3 top-2.5 text-gray-400" size={20} data-id="element-50" />
              </div>
              <button className="text-white hover:text-pink-400 transition relative" data-id="element-51">
                <Heart size={24} data-id="element-52" />
                {wishlist.size > 0 && <span className="absolute -top-2 -right-2 bg-pink-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold" data-id="element-53">
                    {wishlist.size}
                  </span>}
              </button>
              <button className="text-white hover:text-blue-400 transition relative" data-id="element-54">
                <ShoppingCart size={24} data-id="element-55" />
                {cartCount > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold" data-id="element-56">
                    {cartCount}
                  </span>}
              </button>
              <button className="text-white hover:text-blue-400 transition" data-id="element-57">
                <User size={24} data-id="element-58" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Banner */}
      <div className="relative bg-gradient-to-r from-purple-600 via-blue-600 to-cyan-600 py-20 px-6 overflow-hidden" data-id="element-59">
        <div className="absolute inset-0 opacity-20" data-id="element-60">
          <div className="absolute top-10 left-10 text-6xl animate-bounce" data-id="element-61">
            🎁
          </div>
          <div className="absolute top-20 right-20 text-5xl animate-pulse" data-id="element-62">
            ✨
          </div>
          <div className="absolute bottom-10 left-1/4 text-7xl animate-bounce delay-100" data-id="element-63">
            🛍️
          </div>
          <div className="absolute bottom-20 right-1/3 text-6xl animate-pulse delay-200" data-id="element-64">
            💎
          </div>
        </div>
        <div className="container mx-auto text-center relative z-10" data-id="element-65">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4 drop-shadow-lg" data-id="element-66">
            קנה מהעולם עד $150 ללא מכס!
          </h2>
          <p className="text-xl md:text-2xl text-white/90 mb-8 drop-shadow" data-id="element-67">
            אלפי מוצרים ממותגים מובילים • משלוח מהיר לישראל
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4" data-id="element-68">
            <div className="bg-white/20 backdrop-blur-md px-6 py-3 rounded-full shadow-lg" data-id="element-69">
              <span className="text-white font-semibold" data-id="element-70">
                ✓ משלוח מהיר 7-14 יום
              </span>
            </div>
            <div className="bg-white/20 backdrop-blur-md px-6 py-3 rounded-full shadow-lg" data-id="element-71">
              <span className="text-white font-semibold" data-id="element-72">
                ✓ ללא עמלות נסתרות
              </span>
            </div>
            <div className="bg-white/20 backdrop-blur-md px-6 py-3 rounded-full shadow-lg" data-id="element-73">
              <span className="text-white font-semibold" data-id="element-74">✓ החזרות קלות</span>
            </div>
          </div>
        </div>
      </div>

      {/* Shop by Store */}
      <div className="container mx-auto px-6 py-12" data-id="element-75">
        <h2 className="text-3xl font-bold text-white mb-6 flex items-center" data-id="element-76">
          <Tag className="ml-3 text-blue-400" size={32} data-id="element-77" />
          קנה לפי חנות
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-12" data-id="element-78">
          {stores.map(store => <a key={store.name} href={store.url} target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-gray-700 rounded-xl p-6 text-center transition-all hover:scale-105 shadow-lg hover:shadow-2xl group block" data-id="element-79">
              <div className={`text-6xl mb-3 bg-gradient-to-br ${store.color} bg-clip-text text-transparent filter drop-shadow-lg group-hover:scale-110 transition-transform`} data-id="element-80">
                {store.logo}
              </div>
              <h3 className="text-white font-semibold mb-1 text-lg" data-id="element-81">
                {store.name}
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-82">
                {store.items.toLocaleString()} מוצרים
              </p>
            </a>)}
        </div>

        {/* Product Rows */}
        <ProductRow title="🔥 מבצעי בלאק פריידי - הנחות ענק!" products={categories.blackfriday} icon={Flame} data-id="element-83" />
        <ProductRow title="הכי פופולרי השבוע" products={categories.trending} icon={TrendingUp} data-id="element-84" />
        <ProductRow title="אופנה - המבוקשים ביותר" products={categories.fashion} icon={Zap} data-id="element-85" />
        <ProductRow title="אלקטרוניקה מומלצת" products={categories.electronics} icon={Zap} data-id="element-86" />
        <ProductRow title="יופי וטיפוח" products={categories.beauty} icon={Zap} data-id="element-87" />
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-12 mt-20" data-id="element-88">
        <div className="container mx-auto px-6" data-id="element-89">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-90">
            <div data-id="element-91">
              <h3 className="text-white font-bold mb-4 text-lg" data-id="element-92">אודות</h3>
              <ul className="text-gray-400 space-y-2" data-id="element-93">
                <li data-id="element-94">
                  <a href="#" className="hover:text-white transition" data-id="element-95">
                    מי אנחנו
                  </a>
                </li>
                <li data-id="element-96">
                  <a href="#" className="hover:text-white transition" data-id="element-97">
                    איך זה עובד
                  </a>
                </li>
                <li data-id="element-98">
                  <a href="#" className="hover:text-white transition" data-id="element-99">
                    תקנון
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-100">
              <h3 className="text-white font-bold mb-4 text-lg" data-id="element-101">
                שירות לקוחות
              </h3>
              <ul className="text-gray-400 space-y-2" data-id="element-102">
                <li data-id="element-103">
                  <a href="#" className="hover:text-white transition" data-id="element-104">
                    שאלות נפוצות
                  </a>
                </li>
                <li data-id="element-105">
                  <a href="#" className="hover:text-white transition" data-id="element-106">
                    מעקב משלוח
                  </a>
                </li>
                <li data-id="element-107">
                  <a href="#" className="hover:text-white transition" data-id="element-108">
                    החזרות
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-109">
              <h3 className="text-white font-bold mb-4 text-lg" data-id="element-110">קטגוריות</h3>
              <ul className="text-gray-400 space-y-2" data-id="element-111">
                <li data-id="element-112">
                  <a href="#" className="hover:text-white transition" data-id="element-113">
                    אופנה
                  </a>
                </li>
                <li data-id="element-114">
                  <a href="#" className="hover:text-white transition" data-id="element-115">
                    אלקטרוניקה
                  </a>
                </li>
                <li data-id="element-116">
                  <a href="#" className="hover:text-white transition" data-id="element-117">
                    יופי
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-118">
              <h3 className="text-white font-bold mb-4 text-lg" data-id="element-119">
                הישארו מעודכנים
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-120">
                הצטרפו לניוזלטר לקבלת עדכונים
              </p>
              <input type="email" placeholder="אימייל" className="bg-gray-800 text-white px-4 py-2 rounded-lg w-full mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-121" />
              <button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-6 py-2 rounded-lg w-full font-medium transition-all shadow-lg" data-id="element-122">
                הרשמה
              </button>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-gray-400" data-id="element-123">
            <p data-id="element-124">© 2024 150Dollar.com - כל הזכויות שמורות</p>
            <p className="text-sm mt-2" data-id="element-125">
              עיצוב בהשראת Netflix • מיועד לשוק הישראלי
            </p>
          </div>
        </div>
      </footer>
    </div>;
}